export default [{
  path: '/go',
  name: 'Go',
  component: () => import(/* webpackChunkName: "go" */ '../views/go/Index.vue'),
  redirect: { name: 'Go.Battle' },
  meta: {
    title: '围棋',
  },
  children: [
    {
      path: '/go/battle',
      name: 'Go.Battle',
      component: () => import(/* webpackChunkName: "go.battle" */ '../views/go/Battle.vue'),
      meta: {
        title: '对弈练习',
        needLogin: true,
      },
    },
    {
      path: '/go/practice',
      name: 'Go.Practice',
      component: () => import(/* webpackChunkName: "go.practice" */ '../views/go/Practice.vue'),
      meta: {
        title: '闯关做题',
        needLogin: true,
      },
    },
    {
      path: '/go/ai',
      name: 'Go.Ai',
      component: () => import(/* webpackChunkName: "go.ai" */ '../views/go/Ai.vue'),
      meta: {
        title: '挑战AI',
        needLogin: true,
      },
    },
    {
      path: '/go/analyse',
      name: 'Go.Analyse',
      component: () => import(/* webpackChunkName: "go.analyse" */ '../views/go/Analyse.vue'),
      meta: {
        title: '对弈复盘',
        needLogin: true,
      },
    },
  ],
}];
